export const enum ODataOperators {
  SELECT = "$select",
  FILTER = "$filter",
  SKIP = "$skip",
  TOP = "$top",
  EXPAND = "$expand",
  COUNT = "$count",
  COUNTV2 = "$inlinecount",
  ORDER_BY = "$orderby",
  APPLY = "$apply",
  SEARCH = "$search",
}
